@if (!appSettings.isMobile()) {
<div>
    <div class="row mb-3 align-items-end">
        <div class="col-md-12">
            <ng-select
                [items]="brands"
                bindLabel="label"
                bindValue="code"
                [searchFn]="searchBrands"
                [compareWith]="compareCodes"
                [clearable]="true"
                [searchable]="true"
                [multiple]="false"
                placeholder="Buscar marca"
                [ngModel]="filterCode"
                (ngModelChange)="onFilterChange($event)"
                (search)="onSearch($event)">
            </ng-select>
        </div>
    </div>

    <div>
        <div class="table-responsive table-data mb-3">
            <table class="table table-hover table-sm">
                <tbody>
                    @if (isLoading) {
                    @for (i of rows; track $index) {
                    <tr class="tr-custom">
                        <td>
                            <p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p>
                        </td>
                    </tr>
                    }
                    }

                    @for (brand of filteredBrands; track brand.code) {
                    <tr (click)="selectBrand(brand)" [class.active-row]="isSelected(brand)" style="cursor: pointer;">
                        <td class="text-nowrap px-3">
                            <span>{{ brand.name }}</span>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>

            @if (filteredBrands?.length === 0 && !isLoading) {
            <div class="m-l-10 mb-2">
                <em>No hay datos</em>
            </div>
            }
        </div>
    </div>
</div>
} @else {
<app-mobile-footer>
    <input type="search"
           class="form-control mobile-footer-search"
           placeholder="Buscar marca..."
           [(ngModel)]="searchTerm"
           (ngModelChange)="applyFilters()">
</app-mobile-footer>
<div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase">
        REGISTROS @if (!isLoading) { ({{ filteredBrands.length }}) }
    </span>
</div>
<div class="mobile-cards-scroll">
    @if (isLoading) {
        @for (i of rows; track $index) {
            <app-list-card [isLoading]="true"></app-list-card>
        }
    } @else {
        @for (brand of filteredBrands; track brand.code) {
            <app-list-card
                [isShortcut]="true"
                (click)="selectBrand(brand)">
                <div cardTitle class="fw-bold text-dark text-truncate">
                    {{ brand.name }}
                </div>
                <div cardBadge>
                    <span class="badge text-bg-secondary">{{ brand.code }}</span>
                </div>
            </app-list-card>
        }
    }
    @if (!isLoading && filteredBrands.length === 0) {
        <div class="card border-0 shadow-sm p-4 text-center my-2">
            <i class="fas fa-car fa-3x text-muted opacity-50 mb-2"></i>
            <h6 class="text-muted mb-1">Sin marcas</h6>
        </div>
    }
</div>
}
